module.exports = "<!-- Begin:: Header-->\r\n<div>\r\n    <header-top-bar></header-top-bar>\r\n</div>\r\n<!--End:: Header-->\r\n<!--Begin:: Body -->\r\n<div>\r\n    <router-outlet></router-outlet>\r\n</div>\r\n<!-- End:: Body-->\r\n<!-- begin::Footer -->\r\n<div class=\"congress-footer\">\r\n    <footer-bar></footer-bar>\r\n</div>\r\n<!-- end::Footer -->\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/congress/congress.component.html
// module id = ./src/congress/congress.component.html
// module chunks = main